'use client';

import { usePathname } from 'next/navigation';
import Footer from './Footer';

/** Routes where the footer link columns are hidden (also matches /in-prefixed paths). */
const HIDE_FOOTER_LINKS_PATHS = new Set([
  '/',
  '/about-us',
  '/b2b',
  '/privacy-policy',
  '/refund-policy',
  '/terms-and-conditions',
  '/contact-us',
]);

function shouldHideFooterLinks(pathname) {
  if (!pathname) return false;
  if (HIDE_FOOTER_LINKS_PATHS.has(pathname)) return true;
  if (pathname.startsWith('/in')) {
    const rest = pathname === '/in' ? '/' : pathname.slice(3) || '/';
    return HIDE_FOOTER_LINKS_PATHS.has(rest);
  }
  return false;
}

export default function ClientFooter() {
  const pathname = usePathname();

  // Show margin-bottom if pathname includes '/workshops' or ends with 'mentorship-program' or is homepage
  const shouldShowMargin =
    pathname?.includes('/workshops') ||
    pathname?.includes('mentorship-program') ||
    pathname === '/' ||
    pathname === '/in';

  const hideLinksMenu = shouldHideFooterLinks(pathname);

  return (
    <div className={shouldShowMargin ? "mb-20 md:mb-16" : ""}>
      <Footer hideLinksMenu={hideLinksMenu} />
    </div>
  );
}